import 'css/desktop/contact.scss';

import 'js/desktop/common/common.jquery.js';
import 'js/plugin/materialize/input.jquery.js';
import 'js/plugin/form-handler.jquery.js';

let $contactForm = $('#contact-form');

$contactForm.formHandler({
	ajaxOptions: {
		success: function(data) {
			let message = `<div class="card ${data.message.type} white-text">
				<div class="card-content white-text">
				<span class="card-title">${data.message.title}</span>
				<p>${data.message.text}</p>
				</div>
				</div>`;
			$contactForm.replaceWith(message);
		}
	}
});
